<template>
  <div v-if="this.dossier">
    <div v-if="dossier.etat.id == 1">
      <div
        v-for="(part, index) in getParts()"
        :key="index"
        @click="updateDossier()"
      >
        <v-list-item :to="getURI(index)" v-if="part">
          <v-list-item-action>
            <v-icon v-if="isSaved(index)">radio_button_checked</v-icon>
            <v-icon v-else>radio_button_unchecked</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <div v-if="part.stitle">
              <v-list-item-title class="sous-titre"
                >- {{ part.stitle }}</v-list-item-title
              >
            </div>
            <v-list-item-title v-else>{{ part.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "FormulaireMenu",
  props: {},
  data() {
    return {
      partsPermiereDemande: [
        { title: "Demande d'agrément" },
        { title: "Maître de stage à agréer" },
        { title: "Pharmacie d'officine" },
        null,
        { title: "Votre formation continue" },
        { title: "Org. de l'équipe officinale" },
        { title: "Org. de l'équipe officinale", stitle: "Composition" },
        { title: "Org. de l'équipe officinale", stitle: "Formation continue" },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (1/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (2/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (3/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (4/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Qualité à l’officine"
        },
        { title: "Org. de l'équipe officinale", stitle: "Autres" },
        { title: "Conditions de travail des stagiaires" },
        { title: "Projet d'accueil des stagiaires" },
        { title: "Thèse d’exercice" },
        { title: "Motivation et infos complémentaires" },
        { title: "Charte et envoi" }
      ],
      partsRenouvellement: [
        { title: "Demande d'agrément" },
        { title: "Maître de stage à agréer" },
        { title: "Pharmacie d'officine" },
        { title: "Renouvellement d'agrément" },
        { title: "Votre formation continue" },
        { title: "Org. de l'équipe officinale" },
        { title: "Org. de l'équipe officinale", stitle: "Composition" },
        { title: "Org. de l'équipe officinale", stitle: "Formation continue" },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (1/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (2/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (3/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Activité de l'officine (4/4)"
        },
        {
          title: "Org. de l'équipe officinale",
          stitle: "Qualité à l’officine"
        },
        { title: "Org. de l'équipe officinale", stitle: "Autres" },
        { title: "Conditions de travail des stagiaires" },
        { title: "Projet d'accueil des stagiaires" },
        { title: "Thèse d’exercice" },
        { title: "Motivation et infos complémentaires" },
        { title: "Charte et envoi" }
      ]
    };
  },
  computed: {
    ...mapState(["dossier", "formLoading"])
  },
  mounted() {},
  methods: {
    onLoading(bool) {
      this.$store.dispatch("setFormLoading", bool);
    },
    async updateDossier() {
      this.onLoading(true);
      const dossier = await ApiDossierRepository.get(
        this.dossier.id,
        this.dossier.codeAcces
      );
      await this.$store.dispatch("setDossier", dossier);
      this.onLoading(false);
    },
    getParts() {
      if (this.dossier.premiereDemande) return this.partsPermiereDemande;
      return this.partsRenouvellement;
    },
    getURI(part) {
      return "/dossier/" + this.dossier.id + "/part/" + part;
    },
    isSaved(idPart) {
      let parts = JSON.parse(this.dossier.parties);
      if (parts != null)
        return parts.filter(part => part == idPart)[0] != undefined;
      else return false;
    }
  }
};
</script>

<style>
.v-list-item__title {
  font-size: 12px;
}
.sous-titre {
  padding-left: 15px;
}
</style>
